import { PencilCircleIcon } from './PencilCircleIcon';

/**
 * author: GreenTurtwig
 * id F5C5B903-7160-4B46-AC15-28C965289469
 * name pencil-circle
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pencil-circle.svg
 * tags
 * - Drawing / Art 
 */
export const EditCircleIcon = PencilCircleIcon;
export default EditCircleIcon